import { render, staticRenderFns } from "./PurchaseRecord.vue?vue&type=template&id=5d778e8b&scoped=true&"
import script from "./PurchaseRecord.vue?vue&type=script&lang=js&"
export * from "./PurchaseRecord.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseRecord.vue?vue&type=style&index=0&id=5d778e8b&scoped=true&lang=css&"
import style1 from "./PurchaseRecord.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d778e8b",
  null
  
)

export default component.exports